<div style="display: flex; flex-direction: column" class="root">
  <app-navbar></app-navbar>
  <app-application-steps></app-application-steps>
  <div class="app-container">
    <router-outlet></router-outlet>
  </div>
  <app-contact *ngIf="showContact" [outsideCard]="true"></app-contact>
  <app-footer *ngIf="showFooter"></app-footer>
</div>
